<ng-container *ngIf="activities$ | async as activities; else loadingOrError">
  <ng-container *ngIf="activities.data; else noActivities">
    <section class="activities-container">
      <ul class="activities-container__list">
        <li *ngFor="let item of activities.data" class="activities-container__list__item">
          <div class="activities-container__list__icon">
            <a routerLink="/profile" [queryParams]="{p: uuid, u: unit}">
            <img src="assets/images/{{item.category}}.svg" alt="">
            </a>
          </div>
          <div class="activities-container__list__text">
            <p class="activities-container__list__text__title">{{item.text}}</p>
            <p class="activities-container__list__text__infos">{{item.created_at | date: 'dd/MM/yyyy'}} • {{item.created_at | date: 'shortTime'}}</p>
          </div>
        </li>
      </ul>
    </section>
  </ng-container>
   <ng-template #noActivities>
    <div class="activities-container__empty">
      <img src="/assets/images/ico-empty-models.svg" alt="Nenhum registro encontrado">
      <p>Este colaborador não possui nenhuma atividade registrada.</p>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
    <div *ngIf="error$ | async as error; else loading" class="profile-loading error-loading">
        <div *ngIf="error.status === 403">
            <img src="assets/images/ico-erro.svg" alt="" class="fadeInDown">
            <div class="fadeInUp">
                <p>Você não tem permissão para visualizar esta página.</p>
                <small>403 - Acesso Negado</small>
            </div>
        </div>
    </div>
    <ng-template #loading>
        <div class="profile-loading">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
</ng-template>
